import { render, staticRenderFns } from "./a-tutorial-video.vue?vue&type=template&id=d5b085ec&scoped=true&"
import script from "./a-tutorial-video.vue?vue&type=script&lang=js&"
export * from "./a-tutorial-video.vue?vue&type=script&lang=js&"
import style0 from "./a-tutorial-video.vue?vue&type=style&index=0&id=d5b085ec&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b085ec",
  null
  
)

export default component.exports